import { Card, Box, Link, useTheme, Divider, IconButton } from "@mui/material";
import CustomTypography from "../../common/form/CustomTypography";
import avatar from "../../../../assets/man 1.png";
import callIcon from "../../../../assets/fluent_call-16-regular.png";
import emailIcon from "../../../../assets/mdi_email-outline.png";
import companyIcon from "../../../../assets/corporation (1) 1.png";
import { useStores } from "../../../../use-stores";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { OrderTypeEnum } from "../../../../models/ProjectManagement/ProjectManagementBasicDetails";

const CustomerDetailsCard = () => {
  const theme = useTheme();
  const { orderStore, projectManagementStore } = useStores();

  return (
    <Card
      sx={{
        padding: { xl: 4, lg: 3, md: 3, sm: 2, xs: 2 },
        borderRadius: "4px",
        boxShadow: 2,
        WebkitBoxShadow:
          "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
      }}
    >
      <Box pl={2}>
        <CustomTypography variant="heading5" fontWeight={600}>
          Customer Details
        </CustomTypography>
      </Box>
      <Box display="flex" alignItems="center" gap={1} mt={3} pl={2} pr={2}>
        <img src={avatar} alt="avatar" width={24} height={24} />
        <CustomTypography
          variant="body2"
          fontWeight={500}
          color={theme.palette.customColors.greyTextColor}
        >
          {orderStore.orderBasicDetails?.user?.first_name +
            (orderStore.orderBasicDetails?.user?.last_name
              ? " " + orderStore.orderBasicDetails?.user?.last_name
              : "")}
        </CustomTypography>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        gap={1}
        mt={2}
        pl={2}
        pr={2}
        sx={{
          wordBreak: "break-word",
          whiteSpace: "normal",
        }}
      >
        <img src={companyIcon} alt="company" width={24} height={24} />
        <CustomTypography
          variant="body2"
          fontWeight={500}
          color={theme.palette.customColors.greyTextColor}
        >
          {orderStore.orderBasicDetails?.user?.customer_name || ""}
        </CustomTypography>
      </Box>
      <Divider sx={{ mt: 3 }} />
      <Box mt={3} pl={2} pr={2}>
        <CustomTypography variant="heading6" fontWeight={600}>
          Contact
        </CustomTypography>
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          mt={2.9}
          sx={{
            wordBreak: "break-word",
            whiteSpace: "normal",
          }}
        >
          <img src={callIcon} alt="call" width={20} height={20} />
          <CustomTypography
            variant="body2"
            fontWeight={500}
            color={theme.palette.customColors.greyTextColor}
          >
            {orderStore.orderBasicDetails?.user?.phone || ""}
          </CustomTypography>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          mt={2}
          sx={{
            wordBreak: "break-word",
            whiteSpace: "normal",
          }}
        >
          <img src={emailIcon} alt="email" width={20} height={20} />
          <CustomTypography
            variant="body2"
            fontWeight={500}
            color={theme.palette.customColors.greyTextColor}
          >
            {orderStore.orderBasicDetails?.user?.email || ""}
          </CustomTypography>
        </Box>
      </Box>
      <Divider sx={{ mt: 3 }} />
      <Box
        mt={3}
        pl={2}
        pr={2}
        sx={{
          wordBreak: "break-word",
          whiteSpace: "normal",
        }}
      >
        <CustomTypography variant="heading6" fontWeight={600}>
          Billing Address
        </CustomTypography>
        {!orderStore.orderBasicDetails?.billing_address && (
          <Box mt={3}>
            <CustomTypography
              variant="body2"
              fontWeight={500}
              color={theme.palette.customColors.greyTextColor}
            >
              No billing address found
            </CustomTypography>
          </Box>
        )}
        {orderStore.orderBasicDetails?.billing_address && (
          <Box mt={3} sx={{}}>
            {[
              [
                orderStore.orderBasicDetails.billing_address.address1,
                orderStore.orderBasicDetails.billing_address.address2,
                orderStore.orderBasicDetails.billing_address.address3,
              ]
                .filter(Boolean)
                .join(", "),

              [
                orderStore.orderBasicDetails.billing_address.city_name,
                orderStore.orderBasicDetails.billing_address.state_name,
                orderStore.orderBasicDetails.billing_address.country_name,
                orderStore.orderBasicDetails.billing_address.postal_code,
              ]
                .filter(Boolean)
                .join(", "),

              orderStore.orderBasicDetails.billing_address.contact_no,
            ]
              .filter(Boolean)
              .map((field, index) => (
                <CustomTypography
                  key={index}
                  variant="body2"
                  fontWeight={500}
                  color={theme.palette.customColors.greyTextColor}
                >
                  {field}
                </CustomTypography>
              ))}
          </Box>
        )}
      </Box>

      <Divider sx={{ mt: 3 }} />
      <Box
        mt={3}
        pl={2}
        pr={2}
        sx={{
          wordBreak: "break-word",
          whiteSpace: "normal",
        }}
      >
        <CustomTypography variant="heading6" fontWeight={600}>
          Shipping Address
        </CustomTypography>
        {!orderStore.orderBasicDetails?.shipping_address && (
          <Box mt={3}>
            <CustomTypography
              variant="body2"
              fontWeight={500}
              color={theme.palette.customColors.greyTextColor}
            >
              No shipping address found
            </CustomTypography>
          </Box>
        )}
        {orderStore.orderBasicDetails?.shipping_address && (
          <Box mt={3} sx={{}}>
            {[
              [
                orderStore.orderBasicDetails.shipping_address.address1,
                orderStore.orderBasicDetails.shipping_address.address2,
                orderStore.orderBasicDetails.shipping_address.address3,
              ]
                .filter(Boolean)
                .join(", "),

              [
                orderStore.orderBasicDetails.shipping_address.city_name,
                orderStore.orderBasicDetails.shipping_address.state_name,
                orderStore.orderBasicDetails.shipping_address.country_name,
                orderStore.orderBasicDetails.shipping_address.postal_code,
              ]
                .filter(Boolean)
                .join(", "),

              orderStore.orderBasicDetails.shipping_address.contact_no,
            ]
              .filter(Boolean)
              .map((field, index) => (
                <CustomTypography
                  key={index}
                  variant="body2"
                  fontWeight={500}
                  color={theme.palette.customColors.greyTextColor}
                >
                  {field}
                </CustomTypography>
              ))}
          </Box>
        )}
      </Box>
      {orderStore.orderBasicDetails?.proposal_url &&
        orderStore.orderBasicDetails?.type_id !== OrderTypeEnum.POD && (
          <>
            <Divider sx={{ mt: 3 }} />
            <Box mt={3} pl={2} pr={2} display="flex" alignItems="center">
              <CustomTypography variant="heading6" fontWeight={600}>
                Proposal Link
              </CustomTypography>
              <IconButton
                component="a"
                href={orderStore.orderBasicDetails?.proposal_url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                <OpenInNewIcon sx={{ fontSize: "16px" }} color="primary" />
              </IconButton>
            </Box>
          </>
        )}
    </Card>
  );
};

export default CustomerDetailsCard;
